import { useSeo } from "../hooks/useSeo";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../lib/motionx";

// Full policy content provided by Amenity Health Services.
// Rendered as data strings so apostrophes/quotes need no escaping.
const blocks = [
  { t: "h2", text: "Notice of Nondiscrimination" },
  {
    t: "p",
    text:
      "Amenity Health Services comply with applicable Federal civil rights laws and do not discriminate on the basis of age, race, ethnicity, color, national origin, religion, culture, language, physical or mental disability, socioeconomic status, sex, sexual orientation, and gender identity or expression.",
  },
  {
    t: "p",
    text:
      "Amenity Health does not exclude people or treat them differently because of age, race, ethnicity, color, national origin, religion, culture, language, physical or mental disability, socioeconomic status, sex, sexual orientation, gender identity or expression.",
  },
  {
    t: "p",
    text:
      "Amenity Health Services provides free aids and services to people with disabilities to communicate effectively with us, such as:",
  },
  {
    t: "ul",
    items: [
      "Qualified sign language interpreters",
      "Written information in other formats (large print, audio, accessible electronic formats)",
    ],
  },
  {
    t: "p",
    text:
      "Provides free language services to people whose primary language is not English, such as:",
  },
  {
    t: "ul",
    items: [
      "Foreign Language and Qualified sign language interpreters",
      "Information written in other languages",
    ],
  },
  { t: "p", text: "If you need these services, please contact (346) 333-2794" },
  {
    t: "p",
    text:
      "If you believe that Amenity Health Services, PLLC has failed to provide these services or discriminated in another way on the basis of age, race, ethnicity, color, national origin, religion, culture, language, physical or mental disability, socioeconomic status, sex, sexual orientation, and gender identity or expression, you can file a grievance with:",
  },
  {
    t: "ul",
    items: [
      "Emmanuel Castilla, Operations Director",
      "Amenity Health Services, PLLC",
      "Agency address: 4606 1960 Rd W, Suite 520 Houston, Texas 77069",
      "TTY Number: (800)735-2988",
      "Agency Fax: (832)404-2649",
      "Agency email: ecastilla@Amenityhealthsvcs.com",
    ],
  },
  {
    t: "p",
    text:
      "You can file a grievance in person or by mail, fax, or email. If you need help filing a grievance, please contact Emannuel Castilla",
  },
  {
    t: "p",
    text:
      "You can also file a civil rights complaint with the U.S. Department of Health and Human Services, Office for Civil Rights, electronically through the Office for Civil Rights Complaint Portal, available at https://ocrportal.hhs.gov/ocr/portal/lobby.jsf, or by mail or phone at:",
  },
  {
    t: "ul",
    items: [
      "U.S. Department of Health and Human Services",
      "200 Independence Avenue, SW",
      "Room 509F, HHH Building",
      "Washington, D.C. 20201",
      "1 (800) 368-1019, 1 (800) 537-7697 (TDD)",
    ],
  },

  { t: "h2", text: "Privacy Policy" },
  {
    t: "p",
    text:
      "Welcome to Amenity Health Services! Your privacy is of utmost importance to us. This Privacy Policy outlines how we collect, use, and protect your personal information to ensure a secure and confidential experience. We are committed to safeguarding your data and adhering to the highest standards of privacy and security. Please take a moment to review our policy to understand how we handle your information and your rights in relation to it. Through this statement of the privacy policy, Amenity Health Services and Amenity ABA Center also ensures that it has no intention to share or sell the users' confidential information by any means to anyone, in any way.",
  },

  { t: "h3", text: "1. How We May Use and Disclose Your Health Information" },
  {
    t: "p",
    text:
      "We may use and disclose your health information without your authorization for treatment, payment, and health care operation purposes. Examples include but are not limited to:",
  },
  {
    t: "ul",
    items: [
      "Using or sharing your health information with other health care providers involved in your treatment or with a pharmacy that is filling your prescription.",
      "Using or sharing your health information with your health plan to obtain payment for services or using your health information to determine your eligibility for government benefits in a health plan.",
      "Using or sharing your health information to run our business, to evaluate provider performance, to educate health professionals, or for general administrative activities.",
    ],
  },

  { t: "h3", text: "2. Sharing your Information" },
  {
    t: "p",
    text:
      "A. We may share your health information with our business associates who need the information to perform services on our behalf and agree to protect the privacy and security of your health information according to agency standards.",
  },
  {
    t: "p",
    text:
      "B. We may use or share your health information without your authorization as authorized by law for our patient directory, to family or friends involved in your care, or to a disaster relief agency for purposes of notifying your family or friends of your location and status in an emergency situation.",
  },
  {
    t: "p",
    text:
      "C. We may use and disclose your health information without your authorization to contact you for the following activities, as permitted by law and agency policy: providing appointment reminders; describing or recommending treatment alternatives; providing information about health-related benefits and services that may be of interest to you; or fundraising.",
  },
  {
    t: "p",
    text:
      "D. We may also use and disclose your health information without your authorization for the following purposes:",
  },
  {
    t: "ul",
    items: [
      "For public health activities such as reporting diseases, injuries, births or deaths to a public health authority authorized to receive this information, or to report medical device issues to the FDA;",
      "To comply with workers compensation laws and similar programs;",
      "To alert appropriate authorities about victims of abuse, neglect, or domestic violence; if the agency reasonably believes you are a victim of abuse, neglect, or domestic violence we will make every effort to obtain your permission, however, in some cases we may be required or authorized to alert the authorities;",
      "For health oversight activities such as audits, investigations, and inspections of DSHS facilities;",
      "For research approved by an Institutional Review Board or privacy board; for preparing for research such as writing a research proposal; or for research on decedents information;",
      "To create or share de-identified or partially de-identified health information (limited data sets);",
      "For judicial and administrative proceedings such as responding to a subpoena or other lawful order;",
      "For law enforcement purposes such as identifying or locating a suspect or missing person;",
      "To coroners, medical examiners, or funeral directors as needed for their jobs;",
      "To organizations that handle organ, eye or tissue donation, procurement, or transplantation;",
      "To avert a serious threat to health or public safety;",
      "For specialized government functions such as military and veteran activities, national security and intelligence activities, and for other law enforcement custodial situations;",
      "For incidental disclosures such as when information is overheard in a waiting room despite reasonable steps to keep information confidential; and",
      "As otherwise required or permitted by local, state, or federal law.",
    ],
  },
  {
    t: "p",
    text:
      "E. Additional privacy protections under state or federal law apply to substance abuse information, mental health information, certain disease-related information, or genetic information. We will not use or share these types of information unless expressly authorized by law. We will not use or disclose genetic information for underwriting purposes.",
  },
  {
    t: "p",
    text:
      "F. We will always obtain your authorization to use or share your information for marketing purposes, to use or share your psychotherapy notes, if there is payment from a third party, or for any other disclosure not described in this notice or required by law. You have the right to cancel your authorization, except to the extent that we have taken action based on your authorization. You may cancel your authorization by writing to the privacy officer per below.",
  },

  { t: "h3", text: "3. Your Rights" },
  {
    t: "ul",
    items: [
      "Inspect and copy your health information, including lab reports, upon written request and subject to some exceptions. We may charge you a reasonable, cost-based fee for providing records as permitted by law.",
      "Receive confidential communications of your health information, such as requesting that we contact you at a certain address or phone number. You may be required to make the request in writing with a statement or explanation for the request.",
      "Request amendment of your health information in our records. All requests to amend health information must be made in writing and include a reason for the request.",
      "Request an accounting (a list) of certain disclosures of your health information that we make without your authorization. You have the right to receive one accounting free of charge in any twelve-month period.",
      "Request that we restrict how we use and disclose your health information for treatment, payment, and health care operations, or to your family and friends. We are not required to agree to your request, except when you request that we not disclose information to your health plan about services for which you paid with your own money in full.",
      "Obtain a paper copy of this notice upon request.",
    ],
  },

  { t: "h3", text: "4. Our Duties" },
  {
    t: "ul",
    items: [
      "Amenity Health Services & Amenity ABA Center are required to provide you with notice of our legal duties and our privacy practices with respect to your health information. We must maintain the privacy of information that identifies you and notify you in the event your health information is used or disclosed in a manner that compromises the privacy of your health information.",
      "Amenity Health Services & Amenity ABA Center are required to abide by the terms of this notice. We reserve the right to change the terms of this notice and to make the revised notice effective for all health information that we maintain. We will post revised notices on our public website at www.dshs.texas.gov and in waiting room areas. You may request a copy of the revised notice at the time of your next visit.",
    ],
  },

  { t: "h3", text: "5. Links to Other Websites" },
  {
    t: "p",
    text:
      "Our website may include links to affiliate sites and other external websites. Amenity Health Services and Amenity ABA Center are not responsible for the privacy policies, practices, or procedures of these third-party sites. We encourage users to be vigilant when leaving our website and to review the privacy statements of any site that collects personally identifiable information. Please note that this Privacy Policy Agreement applies exclusively to information collected through our own website.",
  },

  { t: "h3", text: "6. Notification and Complaints" },
  {
    t: "ul",
    items: [
      "Amenity Health Services and Amenity ABA Center will notify you immediately if we become aware that an unauthorized person accessed your Personal Health Information.",
      "You have the right to complain to the US Department of Health and Human Services if you feel that your rights have been violated. You can reach DSHS at (512)776-7111 or by email at hipaa.privacy@dshs.texas.gov",
    ],
  },

  { t: "h3", text: "7. Changes to the Privacy Policy" },
  {
    t: "p",
    text:
      "We reserve the right to update our Privacy Policy. Any changes will be posted on this page, and the effective date will be updated accordingly.",
  },

  { t: "h3", text: "8. Acceptance of Terms" },
  {
    t: "p",
    text:
      "By using this website, you are hereby accepting the terms and conditions stipulated within the Privacy Policy Agreement. If you are not in agreement with our terms and conditions, then you should refrain from further use of this site. In addition, your continued use of our website following the posting of any updates or changes to our terms and conditions shall mean that you agree to and accept such changes. We encourage you to periodically review this policy to stay informed about how we are protecting your information.",
  },

  { t: "h3", text: "9. Contact us" },
  {
    t: "p",
    text:
      "If you have any questions or concerns about our Privacy Policy, please contact us at Sbrown@amenityhealthsvcs.com or info@amenityhealthsvcs.com",
  },
];

export default function Privacy() {
  useSeo({
    title: "Privacy Policy & Notice of Nondiscrimination | Amenity Health Services",
    description:
      "Amenity Health Services and Amenity ABA Center Notice of Nondiscrimination and Privacy Policy, including how we use and protect your health information and your rights.",
  });

  return (
    <>
      <PageHeader label="Legal" titleLines={["Privacy Policy"]} />
      <section className="pb-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal>
            <div className="space-y-4">
              {blocks.map((b, i) => {
                if (b.t === "h2")
                  return (
                    <h2
                      key={i}
                      className="font-heading font-semibold text-2xl sm:text-3xl text-ink mt-12 mb-2 pt-6 border-t border-black/5 first:border-0 first:pt-0 first:mt-0"
                    >
                      {b.text}
                    </h2>
                  );
                if (b.t === "h3")
                  return (
                    <h3 key={i} className="font-heading font-semibold text-lg text-ink mt-8 mb-1">
                      {b.text}
                    </h3>
                  );
                if (b.t === "ul")
                  return (
                    <ul key={i} className="list-disc pl-6 space-y-1.5 text-ink/65 leading-relaxed">
                      {b.items.map((it, j) => (
                        <li key={j}>{it}</li>
                      ))}
                    </ul>
                  );
                return (
                  <p key={i} className="text-ink/70 leading-relaxed">
                    {b.text}
                  </p>
                );
              })}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
